export default __webpack_public_path__ + "static/media/bell.af5804f3.svg";